import { Component, Input, OnInit } from '@angular/core';
import { MachinePlacementItemDto } from 'src/app/shared/dtos/machine.dto';
import { TranslocoPipe } from '@jsverse/transloco';
import { PlacementMedia } from 'src/app/core/interfaces/placement-media.interfaces';

@Component({
  standalone: true,
  selector: 'app-placement-media-modal',
  templateUrl: './placement-media-modal.component.html',
  imports: [
    TranslocoPipe,
  ],
})
export class PlacementMediaModalComponent implements OnInit {
  @Input({ required: true }) item!: MachinePlacementItemDto;

  media: PlacementMedia;

  ngOnInit(): void {
    const asset = this.item.item;
    const fileType = asset.file_type.split('/').at(0)!;
    this.media = {
      url: asset.public_asset_url,
      type: fileType,
    };
  }
}